import { render, staticRenderFns } from "./AbbeChat.vue?vue&type=template&id=36299ee9&scoped=true"
import script from "./AbbeChat.vue?vue&type=script&setup=true&lang=js"
export * from "./AbbeChat.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AbbeChat.vue?vue&type=style&index=0&id=36299ee9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36299ee9",
  null
  
)

export default component.exports